module.exports = __webpack_public_path__ + "img/safe_logo.e4c3733f.png";